<script lang="ts">
  import { linkify } from '../../lib/utils/autolink.js'

  interface Props {
    text: string
  }
  const { text }: Props = $props()
  const parts = $derived(linkify(text))
</script>

{#each parts as part}
  {#if part.href}
    <a href={part.href} target="_blank" rel="noopener noreferrer nofollow" data-native>{part.text}</a>
  {:else}{part.text}{/if}
{/each}
